<template>
    <div>
        <section class="q10__jumbotron">
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.oImage1.src,
                    descriptions: [
                        {
                            text: currentPage.images.oImage1.alt,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                        {
                            text: currentPage.images.oImage1.text,
                            position: 'bottom-left', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-selective_green',
                        to: 'to-golden_sand',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.text"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-lg mb-5"
                    v-html="currentPage.content.sArticleDescription.text"
                ></p>

                <TitleParagraph
                    class="mt-8"
                    :options="{
                        from: 'from-selective_green',
                        to: 'to-golden_sand',
                    }"
                >
                    <p
                        class="mt-8 text-xl lg:text-3xl 2xl:text-4xl"
                        v-html="currentPage.content.sSubTitleOne.text"
                    ></p>
                </TitleParagraph>
                <div class="container-components mt-8">
                    <div class="card">
                        <div class="relative pt-6">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'SuPerHydro - Le Fil Express DPIH n°16 - 2 mai 2011'
                                    ),
                                }"
                                class="-top-2 right-2"
                            />
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphOne_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphOne_Content
                                        .text
                                "
                            >
                            </span>
                            <!-- <Dots
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                }"
                            /> -->
                        </paragraph>
                    </div>
                </div>
                <div
                    class="
                        container-timeline-title-si-image-with-description-second-2
                        card
                        relative
                        mt-8
                    "
                >
                    <div class="relative w-full h-full">
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage2.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage2.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                        <div class="q10__textInImage">
                            <h2
                                class="
                                    absolute
                                    inline-block
                                    w-auto
                                    top-0
                                    left-0
                                    font-bold
                                    transform
                                    text-nandor
                                    lg:text-white
                                    -rotate-90
                                    text-right
                                    origin-top-right
                                    text-xl
                                    xl:text-3xl
                                    leading-5
                                    -translate-x-full
                                "
                                v-html="
                                    currentPage.content.sParagraphTwo_Title.text
                                "
                            ></h2>
                            <p
                                class="q10__paragraph"
                                v-html="
                                    currentPage.content.sParagraphTwo_Quote.text
                                "
                            ></p>
                        </div>
                    </div>
                </div>
                <TitleParagraph
                    class="mt-8"
                    :options="{
                        from: 'from-selective_green',
                        to: 'to-golden_sand',
                    }"
                >
                    <p
                        class="mt-8 text-xl lg:text-3xl 2xl:text-4xl"
                        v-html="currentPage.content.sSubTitleTwo.text"
                    ></p>
                </TitleParagraph>
                <div class="timeline hidden lg:flex">
                    <div class="flex text-nandor w-full mt-2">
                        <div
                            class="
                                w-1/3
                                border-r-2 border-nandor
                                mr-2
                                text-right
                                p-2
                                text-base
                            "
                            v-html="
                                currentPage.content
                                    .sParagraphThree_Title_ColOne_Years.text
                            "
                        ></div>
                        <div class="inline-block p-2 w-2/3">
                            <TitleParagraph
                                :options="{
                                    from: 'from-selective_green',
                                    to: 'to-golden_sand',
                                }"
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColOne_Title.text
                                "
                            ></TitleParagraph>
                            <div
                                class="text-base"
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColOne_Content
                                        .text
                                "
                            ></div>
                        </div>
                    </div>

                    <div class="flex text-nandor w-full mt-2">
                        <div
                            class="
                                w-1/3
                                border-r-2 border-nandor
                                mr-2
                                text-right
                                p-2
                                text-base
                            "
                            v-html="
                                currentPage.content
                                    .sParagraphThree_Title_ColTwo_Years.text
                            "
                        ></div>
                        <div class="inline-block p-2 w-2/3">
                            <TitleParagraph
                                :options="{
                                    from: 'from-selective_green',
                                    to: 'to-golden_sand',
                                }"
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColTwo_Title.text
                                "
                            ></TitleParagraph>
                            <div
                                class="text-base"
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColTwo_Content
                                        .text
                                "
                            ></div>
                        </div>
                    </div>

                    <div class="flex text-nandor w-full mt-2">
                        <div
                            class="
                                w-1/3
                                border-r-2 border-nandor
                                mr-2
                                text-right
                                p-2
                                text-base
                            "
                            v-html="
                                currentPage.content
                                    .sParagraphThree_Title_ColThree_Years.text
                            "
                        ></div>
                        <div class="inline-block p-2 w-2/3">
                            <TitleParagraph
                                :options="{
                                    from: 'from-selective_green',
                                    to: 'to-golden_sand',
                                }"
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColThree_Title
                                        .text
                                "
                            ></TitleParagraph>
                            <div
                                class="text-base"
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColThree_Content
                                        .text
                                "
                            ></div>
                        </div>
                    </div>
                </div>
                <div class="timeline flex flex-col lg:hidden">
                    <div class="flex text-nandor w-full mt-2">
                        <div class="w-1/2 flex">
                            <img
                                class="mx-auto w-12 h-12 m-3"
                                :src="
                                    $i18n.locale +
                                    '/images/pages/' +
                                    currentPage.slug +
                                    '/' +
                                    'sageata_verde.png'
                                "
                            />
                            <div
                                class="
                                    border-r-2 border-nandor
                                    mr-2
                                    text-right
                                    p-2
                                    text-base
                                    inline-block
                                "
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColOne_Years.text
                                "
                            ></div>
                        </div>

                        <div class="inline-block p-2 w-1/2">
                            <TitleParagraph
                                :options="{
                                    from: 'from-selective_green',
                                    to: 'to-golden_sand',
                                }"
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColOne_Title.text
                                "
                            ></TitleParagraph>
                            <div
                                class="text-base"
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColOne_Content
                                        .text
                                "
                            ></div>
                        </div>
                    </div>
                    <div class="flex text-nandor w-full mt-2">
                        <div class="w-1/2 flex">
                            <img
                                class="mx-auto w-12 h-12 m-3"
                                :src="
                                    $i18n.locale +
                                    '/images/pages/' +
                                    currentPage.slug +
                                    '/' +
                                    'sageata_verde.png'
                                "
                            />
                            <div
                                class="
                                    border-r-2 border-nandor
                                    mr-2
                                    text-right
                                    p-2
                                    text-base
                                    inline-block
                                "
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColTwo_Years.text
                                "
                            ></div>
                        </div>

                        <div class="inline-block p-2 w-1/2">
                            <TitleParagraph
                                :options="{
                                    from: 'from-selective_green',
                                    to: 'to-golden_sand',
                                }"
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColTwo_Title.text
                                "
                            ></TitleParagraph>
                            <div
                                class="text-base"
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColTwo_Content
                                        .text
                                "
                            ></div>
                        </div>
                    </div>
                    <div class="flex text-nandor w-full mt-2">
                        <div class="w-1/2 flex">
                            <img
                                class="mx-auto w-12 h-12 m-3"
                                :src="
                                    $i18n.locale +
                                    '/images/pages/' +
                                    currentPage.slug +
                                    '/' +
                                    'sageata_verde.png'
                                "
                            />
                            <div
                                class="
                                    border-r-2 border-nandor
                                    mr-2
                                    text-right
                                    p-2
                                    text-base
                                    inline-block
                                "
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColThree_Years.text
                                "
                            ></div>
                        </div>

                        <div class="inline-block p-2 w-1/2">
                            <TitleParagraph
                                :options="{
                                    from: 'from-selective_green',
                                    to: 'to-golden_sand',
                                }"
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColThree_Title.text
                                "
                            ></TitleParagraph>
                            <div
                                class="text-base"
                                v-html="
                                    currentPage.content
                                        .sParagraphThree_Title_ColThree_Content
                                        .text
                                "
                            ></div>
                        </div>
                    </div>
                </div>
                <div class="hidden lg:block">
                    <img
                        class="mx-auto"
                        :src="
                            $i18n.locale +
                            '/images/pages/' +
                            currentPage.slug +
                            '/' +
                            currentPage.images.oImage3.src
                        "
                    />
                </div>
                <div class="container-components mt-8">
                    <div class="card" style="padding: 0;">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFour_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFour_Content
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                    </div>
                    <div class="card break-inside-avoid" style="padding: 0;">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFive_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFive_Content
                                        .text
                                "
                            >
                            </span>
                            <!-- <Dots
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                }"
                            /> -->
                        </paragraph>
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage4.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage4
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.oImage4
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card relative">
                        <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Histoire de la téléconduite hydraulique par Vincent Breuil'
                                ),
                            }"
                            class="top-2 right-2"
                        />
                        <article-note style="overflow: visible;"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage5.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage5.alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: currentPage.images.oImage5.text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                                verticalcontent:
                                    currentPage.content.sParagraphSix_Title
                                        .text,
                                content:
                                    currentPage.content.sParagraphSix_Quote
                                        .text,
                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-4xl lg:text-3xl',
                                    content: '',
                                },
                                margin: {},
                            }"
                        />
                    </div>
                </div>
                <div class="mt-8 relative">
                    <hotspot-richmedia
                        :options="{
                            icon: 'diaporama',
                            collection: getRichmediaByCollection(
                                currentPage,
                                'Le projet national MRCD'
                            ),
                        }"
                        class="top-2 right-2"
                    />
                    <image-with-descriptions
                        :options="{
                            image:
                                'pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.oImage6.src,
                            descriptions: [
                                {
                                    text: currentPage.images.oImage6.alt,
                                    position: 'top-left', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: currentPage.images.oImage6.text,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                            ],
                        }"
                    />
                </div>
                <TitleParagraph
                    class="mt-8"
                    :options="{
                        from: 'from-selective_green',
                        to: 'to-golden_sand',
                    }"
                >
                    <p
                        class="mt-8 text-xl lg:text-3xl 2xl:text-4xl font-bold"
                        v-html="currentPage.content.sSubTitleThree.text"
                    ></p>
                </TitleParagraph>
                <div class="container-components mt-8">
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphSeven_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphSeven_Content
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                    </div>
                    <div class="card">
                        <div class="break-inside-avoid">
                            <div class="relative pt-14">
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            'Etudes de dangers, exporter la sûreté à la française'
                                        ),
                                    }"
                                    class="top-2 right-2"
                                />
                            </div>
                            <TitleParagraph
                                :options="{
                                    from: 'from-selective_green',
                                    to: 'to-golden_sand',
                                }"
                            >
                                <span
                                    v-html="
                                        currentPage.content
                                            .sParagraphEight_Title.text
                                    "
                                ></span>
                            </TitleParagraph>
                        </div>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphEight_Content
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                    </div>
                    <div class="card">
                        <div class="relative pt-10">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Débit réservé : objectif, mise en conformité'
                                    ),
                                }"
                                class="-top-2 right-2"
                            />
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphNine_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphNine_Content
                                        .text
                                "
                            >
                            </span>
                            <router-link
                                :to="{
                                    name: 'catalogue',
                                    params: { slug: 'page-035' },
                                }"
                                v-html="
                                    currentPage.content
                                        .sParagraphNine_Content_03.text
                                "
                            ></router-link>
                            <span
                                v-html="
                                    currentPage.content
                                        .sParagraphNine_Content_02.text
                                "
                            >
                            </span>
                            <!-- <Square
                                :options="{
                                    from: 'feijoa',
                                    to: 'selective_green',
                                }"
                            /> -->
                        </paragraph>
                    </div>
                </div>
                <div class="mt-8">
                    <image-with-descriptions
                        :options="{
                            image:
                                'pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.oImage7.src,
                            descriptions: [
                                {
                                    text: currentPage.images.oImage7.alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: currentPage.images.oImage7.text,
                                    position: 'top-left', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                            ],
                        }"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.q10__textInImage {
    position: absolute;
    bottom: 5%;
    left: 0;
    padding: 0 3rem;
    width: 100%;
    column-count: 3;
    margin: 1rem;
    @media (max-width: 768px) {
        padding: 0;
        position: relative;
        column-count: unset;
        margin: 1rem 0 0 0;
    }

    .q10__title {
        position: absolute;
        top: 0;
        left: 0;
        transform: rotate(-90deg);
        color: white;
        text-align: end;
        line-height: 1;
        font-weight: bold;

        @media (max-width: 768px) {
            @apply text-nandor;
        }
    }
    .q10__paragraph {
        margin-left: 3rem;
        color: white;
        @media (max-width: 768px) {
            @apply text-nandor;
        }
    }
}

.timeline {
    // column-width: 380px;
    // column-gap: 40px;
    position: relative;
    margin: 5px 0;
    padding: 0;
    width: 100%;
    height: auto;
}
</style>
